<script lang="ts">
  import Landing from "@modern/components/retailer/SpecsOnboarding/Landing.svelte";
  import SignUpWrapper from "@modern/components/retailer/SpecsOnboarding/SignUpWrapper.svelte";

  export let accountNumber: string;
  export let initializationVector: string;

  let showSignupFlow = false;

  const onSignupClicked = () => (showSignupFlow = true);

</script>

{#if showSignupFlow}
  <SignUpWrapper {accountNumber} {initializationVector} />
{:else}
  <Landing {onSignupClicked} />
{/if}
